const initializedSections = new WeakSet();

const sectionsIn = (scope = document) => {
  if (!scope) {
    return [];
  }

  if (scope.matches?.('[data-form-runtime]')) {
    return [scope];
  }

  return Array.from(scope.querySelectorAll?.('[data-form-runtime]') || []);
};

const setActivePanel = (section, panelId) => {
  section.querySelectorAll('[data-form-runtime-panel]').forEach((panel) => {
    const isActive = panel.dataset.formRuntimePanel === panelId;

    panel.hidden = !isActive;
    panel.toggleAttribute('inert', !isActive);
    panel.setAttribute('aria-hidden', String(!isActive));
  });
};

const initFormRuntimeTabs = (scope = document) => {
  sectionsIn(scope).forEach((section) => {
    if (initializedSections.has(section)) {
      return;
    }

    const tabs = section.querySelector('[data-form-runtime-tabs]');

    if (!tabs) {
      initializedSections.add(section);
      return;
    }

    const controls = Array.from(tabs.querySelectorAll('[data-form-runtime-tab]'));
    const activeControl = controls.find((control) => control.checked) || controls[0];

    if (!activeControl) {
      return;
    }

    initializedSections.add(section);
    activeControl.checked = true;
    setActivePanel(section, activeControl.value);

    tabs.addEventListener('change', (event) => {
      const control = event.target.closest?.('[data-form-runtime-tab]');

      if (!control || !control.checked) {
        return;
      }

      setActivePanel(section, control.value);
    });
  });
};

initFormRuntimeTabs();
window.initFormRuntimeTabs = initFormRuntimeTabs;
